/*!
e
=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Business } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";

class Index extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={"Relatie overzicht"} />
        <GridContainer>
          {this.props.vestiging_id ? (
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} /> Nieuwe relatie
                </Button>
              </Link>
            </GridItem>
          ) : null}
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"companyName"}
              fieldKey={"relations:companyName"}
              operator={"like"}
              placeholder={getTranslation("Filter on company name")}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "apiId", editable: false },
                { dbfield: "companyName", editable: false },
                { dbfield: "zipcode", editable: false },
                { dbfield: "city", editable: false },
                { dbfield: "email", editable: false },
                { dbfield: "orderCount", editable: false },
              ]}
              editLink={"./:id/edit"}
              editLinkPermission={"relations/:id/edit"}
              fetchUrl={"core/relations"}
              filters={this.props.filters}
              headerIcon={<Business />}
              headers={[
                { label: "#", sortable: true, sortKey: "id" },
                { label: "API #", sortable: true, sortKey: "apiId" },
                {
                  label: "Bedrijfsnaam",
                  sortable: true,
                  sortKey: "companyName",
                },
                { label: "Postcode", sortable: true, sortKey: "zipcode" },
                { label: "Plaats", sortable: true, sortKey: "city" },
                { label: "Email", sortable: true, sortKey: "email" },
                { label: "Orders", sortable: true, sortKey: "orderCount" },
              ]}
              reduxKey={"relations"}
              showAutoRenew
              tableTitle={<TranslationWrapper tDefault={"Relaties"} tKey={"relations.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["relations:companyName"]) {
    filters["relations:companyName"] = state.filtersV2["relations:companyName"];
  }
  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
